import { type SelectOption } from './SelectDropdown'

export const dropdownSectionHeader = (id: string, label: string): SelectOption => ({
  id: `header:${id}`,
  label,
  displayLabel: <span className='paragraph-small bold zocks-text-gray-600 text-uppercase'>{label}</span>,
  disabled: true,
  className: 'pt-1',
})

export const dropdownMessage = (text: string): SelectOption => ({
  id: 'message',
  label: text,
  displayLabel: <span className='paragraph-small zocks-text-gray-500'>{text}</span>,
  disabled: true,
})
